import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { _getAllFeedbacks } from '../shared/httpservice/apis/feedback';
const createInitialState = () => ({
    loading: false,
    response: null,
    hasError: false,
    error: {},
});
const initialState = {
    feedbacks: createInitialState(),
};
export const fetchAllFeedbacks = createAsyncThunk('feedback/fetchAll', async ({ siteId, pageNumber = 0, pageSize = 10 }, { rejectWithValue }) => {
    try {
        const response = await _getAllFeedbacks(siteId, pageNumber, pageSize);
        return response;
    }
    catch (error) {
        return rejectWithValue(error?.response?.data || error.message);
    }
});
const feedbackSlice = createSlice({
    name: 'feedback',
    initialState,
    reducers: {
        resetFeedbackSlice: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllFeedbacks.pending, (state) => {
            state.feedbacks.loading = true;
            state.feedbacks.hasError = false;
        })
            .addCase(fetchAllFeedbacks.fulfilled, (state, action) => {
            state.feedbacks.loading = false;
            state.feedbacks.response = action.payload;
            state.feedbacks.hasError = false;
        })
            .addCase(fetchAllFeedbacks.rejected, (state, action) => {
            state.feedbacks.loading = false;
            state.feedbacks.hasError = true;
            state.feedbacks.error = action.payload;
        });
    },
});
export const { resetFeedbackSlice } = feedbackSlice.actions;
export default feedbackSlice.reducer;
